import { createSelector } from '@ngrx/store';
import { ProductState } from '../reducers/product.reducer';
import { selectProductState } from '../reducers';

export const getProductsTableState = createSelector(
  selectProductState,
  (state: ProductState) => { return { total: state.total, currentPage: state.currentPage, perPage: state.perPage, order: state.order, direction: state.direction, filters: state.filters, includes: state.includes } }
);

export const getProducts = createSelector(
  selectProductState,
  (state: ProductState) => state.list
);


export const getTotalProducts = createSelector(
  getProductsTableState,
  (tableState) => tableState.total
);

export const getProductsCurrentPage = createSelector(
  getProductsTableState,
  (tableState) => tableState.currentPage
);

export const getProductsPerPage = createSelector(
  getProductsTableState,
  (tableState) => tableState.perPage
);

export const getProductsOrder = createSelector(
  getProductsTableState,
  (tableState) => tableState.order
);

export const getProductsDirection = createSelector(
  getProductsTableState,
  (tableState) => tableState.direction
);

export const getFilters = createSelector(
  getProductsTableState,
  (tableState) => tableState.filters
);

export const getProductsDialogId = createSelector(
  selectProductState,
  (state: ProductState) => state.dialogId
);

export const getSelectedProduct = createSelector(
  selectProductState,
  (state: ProductState) => state.products
);
export const getSelectionDialogId = createSelector(
  selectProductState,
  (state: ProductState) => state.selectionDialogId
);

export const getSelectedProducts = createSelector(
  selectProductState,
  (state: ProductState) => state.selectedProducts
);

